<template>
  <BTable
    class="BTablePublications"
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.name="{ header, item, value: v }">
      <v-icon
        v-if="!item.archived_at"
        color="success"
        size="16px"
        class="mr-2"
        v-text="'mdi-checkbox-marked-outline'"
      />

      <v-icon
        v-else
        color="error"
        size="16px"
        class="mr-2"
        v-text="'mdi-close-circle-outline'"
      />

      <v-icon
        v-if="item.is_redirect_to_self"
        size="16px"
        class="mr-2"
        v-text="'mdi-share'"
      />

      <router-link
        v-if="header.getRoute"
        :to="header.getRoute(item)"
        v-text="v"
      />

      <template v-else>
        {{ v }}
      </template>
    </template>

    <template #item.topic_ids="{ header, item, value: v }">
      <span
        v-if="header.getTopicNames"
        v-text="header.getTopicNames(item, topics)"
      />
      <template v-else>
        {{ v }}
      </template>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Publications/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublications',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    topics: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

